import type {
  AudienceArtifact,
  ProjectorState,
  RoomThread,
} from "../../shared/types.ts";
import {
  OnScreenStatus,
  ProjectorControls,
  currentProjectedThread,
  type ProjectorStripActions,
} from "../components/OnScreen.tsx";

/**
 * Left-rail projector card: a read-only mirror of what the room screen is
 * showing (mode + top item) merged with the global projection controls.
 * Composed from the shared OnScreenStatus + ProjectorControls blocks — the
 * moderator renders the same pair in its own card.
 */
export function ProjectorCard({
  projector,
  threads,
  artifacts,
  actions,
  pending = false,
}: {
  projector: ProjectorState | null;
  threads: RoomThread[];
  artifacts: AudienceArtifact[];
  actions: ProjectorStripActions;
  pending?: boolean;
}) {
  return (
    <section className="onscreen projcard" data-testid="admin2-onscreen">
      <OnScreenStatus
        projector={projector}
        threads={threads}
        artifacts={artifacts}
      />
      <ProjectorControls
        projector={projector}
        current={currentProjectedThread(projector, threads)}
        pending={pending}
        actions={actions}
      />
    </section>
  );
}
